<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >

    <template #layoutContent>
      <ActionsBar :query="query" :handleRangeDate="handleRangeDate" :types="expenseTypes" :status="expenseStatus" id="expense-datepicker"/>

      <Card class="my-5">
        <template #cardBody>
          <h3>{{$t('expense.stat.title')}}</h3>
          <div class="flex-md-row d-flex scroll-x mt-5 py-5">
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <div class="card p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8 bg-secondary">
                      <span class="text-black">{{ userExpensesStats.total }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.total') }} </h3>
                      <span class="fs-6 fw-bolder">
                        {{ formattedLocalAmount(userExpensesStats.amount) }} {{ userExpensesStats.currency }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.remaining_color) }" :class="'bg-'+ userExpensesStats.remaining_color">
                      <span class="text-white">{{ userExpensesStats.remaining_count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.remaining') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.remaining_color) }" :class="'text-'+userExpensesStats.remaining_color">
                        {{ formattedLocalAmount(userExpensesStats.remaining_amount) }} {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4 ">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.unapproved_color) }" :class="'bg-'+ userExpensesStats.unapproved_color">
                      <span class="text-white">{{ userExpensesStats.unapproved_count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.unapproved') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.unapproved_color) }" :class="'text-'+userExpensesStats.unapproved_color">
                        {{ formattedLocalAmount(userExpensesStats.unapproved_amount) }}
                        {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.unvalidated_color) }" :class="'bg-'+ userExpensesStats.unvalidated_color">
                      <span class="text-white">{{ userExpensesStats.unvalidated_count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.unvalidated') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.unvalidated_color) }" :class="'text-'+userExpensesStats.unvalidated_color">
                        {{ formattedLocalAmount(userExpensesStats.unvalidated_amount) }}
                        {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.reject_color) }" :class="'bg-'+ userExpensesStats.reject_color">
                      <span class="text-white">{{ userExpensesStats.reject_count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.rejected') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.reject_color) }" :class="'text-'+userExpensesStats.reject_color">
                        {{ formattedLocalAmount(userExpensesStats.reject_amount) }}
                        {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.validated_color) }" :class="'bg-'+ userExpensesStats.validated_color">
                      <span class="text-white">{{ userExpensesStats.validated_count }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.validated') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.validated_color) }" :class="'text-'+userExpensesStats.validated_color">
                        {{ formattedLocalAmount(userExpensesStats.validated_amount) }}
                        {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
            <div class="col-12 col-md-2 me-md-4 mb-4">
              <Card class="p-3 h-100 bg-light-primary">
                <div class="d-flex flex-stack">
                  <div class="symbol symbol-40px me-4">
                    <div class="symbol-label fs-2 py-10 px-8" :style="{ backgroundColor: $getCssVariable(userExpensesStats.paid_color) }" :class="'bg-'+ userExpensesStats.paid_color">
                      <span class="text-white">{{userExpensesStats.paid_count}}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center flex-row-fluid flex-wrap">
                    <div class="flex-grow-1 me-2">
                      <h3> {{ $t('expense.stat.paid') }} </h3>
                      <a class="fs-6 fw-bolder" :style="{ color: $getCssVariable(userExpensesStats.paid_color) }" :class="'text-'+userExpensesStats.paid_color">
                        {{ formattedLocalAmount(userExpensesStats.paid_amount) }}
                        {{ userExpensesStats.currency }}
                      </a>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </template>
      </Card>

      <Card :title="$t('expense.list')" containerClass="mb-5 mt-5">
        <template #cardToolbar>
          <Button v-if="$can(abilities.CREATE_EXPENSE_REPORT) || $can(abilities.CREATE_EXPENSE_OFFICE)" type="new" btn-class="btn-sm" btn-text="expense.create" @click.prevent="toggleNewExpenseModal" ></Button>
        </template>
        <template #cardBody>
          <div class="row bg-gray-100 border-bottom">
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('expense.table.title') }}</div>
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('expense.table.amount') }}</div>
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('expense.table.type') }}</div>
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('expense.table.status') }} </div>
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('expense.table.date') }}</div>
            <div class="col-2 fw-bold fs-5 py-5">{{ $t('label.action') }}</div>
          </div>
          <div id="scrollable-list-container" class="row border border-bottom scroll-y" style="max-height: 400px!important;">
            <div class="h-200px d-flex justify-content-center align-items-center" v-if="isLoading">
              <div class="text-center">
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">{{ $t("loadingText") }}</span>
                </div>
              </div>
            </div>
            <div class="h-350px d-flex justify-content-center align-items-center" v-else-if="!userExpenses.length">
              <div class=" text-center ">
                <div class="pt-8 ">
                  <Img filename="empty.png" alt=""
                       class="mw-100 h-125px h-sm-175px" />
                </div>
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('expense.noData') }}</h2>
              </div>
            </div>
            <template v-else v-for="(expense, index) in userExpenses" :key="index">
              <div class="col-2 py-4"> {{ expense.title }} </div>
              <div class="col-2 py-4"> {{ formattedLocalAmount(expense?.fees_sum_amount) }} {{ expense?.currency?.symbol }} </div>
              <div class="col-2 py-4">
                <span class="badge" :class="'badge-'+expense.type_color"> {{ expense['type_'+locale] }}  </span>
              </div>
              <div class="col-2 py-4">
                <span class="badge" :style="{ backgroundColor: $getCssVariable(expense.status_color)}" > {{ expense['status_'+locale] }}  </span>
              </div>
              <div class="col-2 py-4"> {{ new Date(expense.created_at)?.toLocaleDateString() }} </div>
              <div class="col-2 py-4">
                <div class="d-flex">
                  <a href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.show')" @click.prevent="() => showExpense(expense.id)"> <i :data-id="expense.id" class="fas fa-eye fs-2"></i> </a>
                  <a href="#" v-if="canEdit(expense?.status)" class="btn btn-sm btn-clean btn-icon" :title="$t('button.edit')" @click.prevent="() => editExpense(expense.id)"> <i class="fas fa-edit fs-2"></i> </a>
                  <a v-if="expense.status === expenseStatusEnums.DRAFT" href="#" class="btn btn-sm btn-clean btn-icon" :title="$t('button.delete')" @click.prevent="() => deleteExpense(expense.id)"> <i class="fas fa-trash fs-2"></i> </a>
                </div>
              </div>
            </template>
          </div>
        </template>
      </Card>
    </template>
  </SubLayout>
  <div class="modal fade" id="new-expense-modal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('expense.new.title') }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="toggleNewExpenseModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
            <div v-for="(type, index) in expenseTypes" class="col" :key="index">
              <Card class="cursor-pointer" :variant="type.color" v-if="$can(getPermission(type.title))"  @click.prevent="openCreateView(type.id, type.title)">
                <div class="text-center py-5">
                  <span class="font-bold font-white fs-2"> {{ type[locale] }} </span>
                </div>
              </Card>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <Button type="cancel" @click.prevent="toggleNewExpenseModal" id="cancel_btn" btn-class="btn-sm" size="7px 30px" btn-text="button.cancel"></Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, onMounted, reactive, ref, watch} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useStore} from "vuex";
import i18n from "@/plugins/i18n";
import {formattedLocalAmount} from "@/mixins/Helpers";
import {useRouter} from "vue-router";
import {useLocales} from "@/composables/locales";
import {useHasAbility} from "@/composables/hasAbility";
import Card from "@/components/Card";
import Button from "@/components/Button.vue";
import ActionsBar from "@/Modules/Financial/views/Expense/components/ActionsBar.vue";
import {useSwal} from "@/composables/useSwal";
import abilities from "@/composables/abilities";
import {useExpenseEnums} from "@/Modules/Financial/composables/expenseEnums";
import Img from "@/components/Img.vue";
import StatCard from "@/Modules/Financial/components/StatCard.vue";


const router = useRouter()
const store = useStore()
const { can } = useHasAbility()
const {locale, datatableLocaleUrl} = useLocales()
const { expenseStatusEnums } = useExpenseEnums()

const {showSwal} = useSwal()
const title = ref("breadcrumbs.expense.title")
const breadcrumbs = ref([
{
  name: 'breadcrumbs.expense.list',
  route: 'expenses'
}
])

const table = ref()
const isLoading = ref(false)
const query = ref({
  status: '',
  type: '',
  start_date: '',
  end_date: '',
  search: ''
})
const userExpensesMetaData = reactive({
  current_page: 1,
  last_page: 1,
  next_page: null
})
const userExpenses = ref([])
const userExpensesStats = ref({
  unvalidated_color: "",
  unvalidated_count: "",
  unvalidated_amount: "",
  unapproved_color: "",
  unapproved_count: "",
  unapproved_amount: "",
  validated_color: "",
  validated_count: "",
  validated_amount: "",
  paid_color: "",
  paid_count: "",
  paid_amount: "",
  remaining_color: "",
  remaining_count: "",
  remaining_amount: "",
  reject_color: "",
  reject_count: "",
  reject_amount: "",
  currency: '',
  amount: ""
})

const defaultCurrency = computed(() => store.getters['company/getCompanyCurrency'])
const expenseStatus = computed(() => store.getters['expenses/expenseStatus'])
const expenseTypes = computed(() => store.getters['expenses/expenseTypes'])
const canEdit = (status) => {
  return status == expenseStatusEnums.value.DRAFT || status == expenseStatusEnums.value.REJECTED
}

watch(() => [query.value.status, query.value.start_date, query.value.end_date, query.value.search, query.value.type], (newValue) => {
  fetchUserExpenseData(true)
})

const getPermission = (typeId) => {
  return typeId === 'REPORT' ? abilities.CREATE_EXPENSE_REPORT : abilities.CREATE_EXPENSE_OFFICE;
};

const fetchUserExpenseData = (restart = false, page = null) => {
  if(query.value.start_date){
    isLoading.value = true
    let filter = `?expenseStatus=${query.value.status}&date_start=${query.value.start_date}&date_end=${query.value.end_date}&search=${query.value.search}&typeSelected=${query.value.type}`
    if(page) filter += `&page=${page}`
    store.dispatch('expenses/loadUserExpenses', filter)
        .then(res => {
          if(!userExpenses.value.length || restart) {
            userExpensesMetaData.current_page = res.expenses.current_page
            userExpensesMetaData.last_page = res.expenses.last_page
            userExpensesMetaData.next_page = res.expenses.next_page
            userExpenses.value = res.expenses.data
            return;
          }
          userExpensesMetaData.current_page = res.expenses.current_page
          userExpensesMetaData.last_page = res.expenses.last_page
          userExpensesMetaData.next_page = res.expenses.next_page
          const data = Array.isArray(res.expenses.data) ? res.expenses.data : Object.values(res.expenses.data)
          userExpenses.value = userExpenses.value.concat(data)
        }).finally(() => isLoading.value = false)

    store.dispatch('expenses/loadUserExpensesStatistic', filter)
        .then(res => {
          userExpensesStats.value = res.stats.reduce((acc, curr) => {
            Object.keys(curr).forEach(key => {
              acc[key] = parseInt(acc[key]) ? (acc[key] || 0) + curr[key] : curr[key];
            });
            return acc;
          }, {});
          userExpensesStats.value.currency = defaultCurrency.value?.symbol || res.stats[0]?.currency_iso
        })
        .catch(err => {})
        .finally(() => {

        })
  }
}
const loadNextPage = () => {
  const container = document.getElementById('scrollable-list-container');

  container.addEventListener('scroll', () => {
    if (container.scrollTop + container.clientHeight >= container.scrollHeight - 50) {
      if (!isLoading.value) {
        if(userExpensesMetaData.current_page < userExpensesMetaData.last_page){
          fetchUserExpenseData(false, userExpensesMetaData.current_page + 1);
        }
      }
    }
  });
};
function handleRangeDate (range) {
  query.value.start_date = range.start_date
  query.value.end_date = range.end_date
}
function openCreateView(typeId, type){
  toggleNewExpenseModal()
  router.push({ name: 'expenses-create', params: { typeId, type, } })
}
const toggleNewExpenseModal = () => {
  $('#new-expense-modal').modal('toggle')
}
const showExpense = (id) => {
  router.push({ name: 'expenses-view', params: { id } })
}
const editExpense = (id) => {
  router.push({ name: 'expenses-edit', params: { id } })
}
function deleteExpense(id){
  showSwal(
        i18n.global.t('expense.swal.deleted'),
        i18n.global.t('expense.swal.deleted_text')
    ).then( async (result) => {
        if (result.value) {
            store.dispatch('expenses/deleteExpense', id)
                .then(() => {
                    window.toastr['success'](i18n.global.t('finance.notification.expense_deleted'))
                    table.value.ajax.reload()
                    closeModal()
                })
                .catch(() => {

                })
        }
    })
}


function loadData() {
  Promise.all([
    store.dispatch('expenses/loadExpenseStatus'),
    store.dispatch('expenses/loadExpenseTypes'),
    fetchUserExpenseData(),
    loadNextPage()
  ])
}

onMounted( () => {
  loadData()
})


</script>

<style scoped>
.color {
  color: #d0cfcf;
}
</style>
